import axios from 'axios';
import { toast } from 'react-toastify';

// Axios instance
const apiClient = axios.create({
  baseURL: process.env.REACT_APP_FINNHUB_BASE_URL,
  params: {
    token: process.env.REACT_APP_FINNHUB_API_KEY,
  },
});

// Fetch stock list
export const fetchStocks = async () => {
  try {
    const response = await apiClient.get('/stock/symbol', {
      params: { exchange: 'US' },
    });

    return response.data.map((stock) => ({
      symbol: stock.symbol,
      name: stock.description,
      price: Math.random() * 100, // Dummy data for prices
      changePercent: Math.random() * 5, // Dummy data for change percentage
      volume: Math.floor(Math.random() * 100000), // Dummy volume
      marketCap: Math.random() * 1000000, // Dummy market cap
    }));
  } catch (error) {
    handleApiError(error, (error.response.data.error ?? 'Error fetching stocks'));
    return []; // Return empty array on error
  }
};

// Fetch historical data
export const fetchHistoricalData = async (symbol) => {
  const now = Math.floor(Date.now() / 1000);
  const past = now - 30 * 24 * 60 * 60; // Last 30 days

  try {
    const response = await apiClient.get('/stock/candle', {
      params: {
        symbol,
        resolution: 'D',
        from: past,
        to: now,
      },
    });
    return response.data;
  } catch (error) {
    handleApiError(error, (error.response.data.error ?? `Error fetching historical data for ${symbol}`));
    return null; // Return null on error
  }
};

// Fetch stock news
export const fetchNews = async (category) => {
  try {
    const response = await apiClient.get('/news', {
      params: { category },
    });
    return response.data;
  } catch (error) {
    // Use optional chaining to safely access nested properties
    handleApiError(
      error,
      error.response?.data?.error ?? `Error fetching news for category: ${category}`
    );
    return []; // Return an empty array on error
  }
};


// Centralized error handler with Toast
const handleApiError = (error, defaultMessage) => {
  if (error.response) {
    // Server responded with a status other than 2xx
    const message = `${defaultMessage}: ${error.response.status}`;
    toast.error(defaultMessage);
    /*
    if (error.response.status === 403) {
      toast.error('Access denied. Please check your API key or permissions.');
    }
    */
    console.error(message);
  } else if (error.request) {
    // Request was made but no response received
    toast.error('Network error. Please check your connection.');
    console.error(`${defaultMessage}: No response received.`);
  } else {
    // Something else happened
    toast.error('An unexpected error occurred. Please try again later.');
    console.error(`${defaultMessage}: ${error.message}`);
  }
};
